import activeResponse from './activeResponse.json';
import common from './common.json';
import integrations from './integrations.json';

const en = {
  activeResponse,
  common,
  integrations,
  organizationProfile: 'Organization Profile',
};

export default en;
